import SectionHeading from '@/pages/home/components/SectionHeading';
import { storyFacts, storyParagraphs } from '@/mocks/home';

export default function StorySection() {
  return (
    <section id="story" className="bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="剧情简介"
          title="一场同学会，把十年前的账重新翻了出来"
          desc="如果你只想用五分钟了解这剧的骨架，看完这一段就够了。"
        />

        <div className="mt-10 grid grid-cols-1 gap-10 md:mt-14 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16">
          <div className="reveal space-y-5">
            {storyParagraphs.map((paragraph, index) => (
              <p
                key={index}
                className="text-sm leading-8 text-foreground-700 md:text-base md:leading-9"
              >
                {paragraph}
              </p>
            ))}

            <div className="flex flex-wrap gap-2 pt-2">
              {['重逢', '旧账', '回闪', '边界', '摊牌'].map((keyword) => (
                <span
                  key={keyword}
                  className="rounded-full border border-background-300 bg-background-100 px-3 py-1 text-xs font-medium text-foreground-700"
                >
                  {keyword}
                </span>
              ))}
            </div>
          </div>

          <div className="reveal">
            <div className="overflow-hidden rounded-lg border border-background-200">
              <div className="h-56 w-full md:h-72">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20an%20empty%20school%20classroom%20corridor%20at%20dusk%20with%20tall%20windows%20casting%20long%20warm%20shadows%20across%20worn%20wooden%20floors%2C%20dust%20motes%20floating%20in%20golden%20light%2C%20nostalgic%20muted%20amber%20and%20sepia%20tone%2C%20shallow%20depth%20of%20field%2C%20subtle%20film%20grain%2C%20editorial%20atmospheric%20photography%2C%20no%20people&width=1200&height=800&seq=ds-story-01&orientation=landscape"
                  alt="黄昏时分空旷的学校走廊，长窗投下暖色光影，呼应剧中校园往事"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>

            <dl className="mt-4 overflow-hidden rounded-lg border border-background-200 bg-background-100">
              {storyFacts.map((fact, index) => (
                <div
                  key={fact.label}
                  className={`flex flex-col gap-1 px-5 py-3 sm:flex-row sm:items-center sm:gap-4 ${
                    index !== storyFacts.length - 1 ? 'border-b border-background-200' : ''
                  }`}
                >
                  <dt className="w-24 shrink-0 text-xs font-medium text-foreground-500 md:text-sm">
                    {fact.label}
                  </dt>
                  <dd className="text-sm font-medium text-foreground-900">{fact.value}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}